import 'css-chunksrc/client/common/filterMenu/organizationalUnits/styles.scss';export default {
  "header": "_header_dk0k1_1",
  "icon": "_icon_dk0k1_10",
  "title": "_title_dk0k1_18",
  "list": "_list_dk0k1_25",
  "scrollPane": "_scrollPane_dk0k1_29"
};